/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react"
import { useParams } from 'react-router'
import GridContainer from '../components/GridContainer'
import Image from '../components/Image'
import Header from '../components/Header'
import logoVote from '../assets/images/vote-for-your-weekend.svg'
import { FirestoreService } from '../lib/firestore'
import { useCookies } from 'react-cookie';
import { Link } from "react-router-dom"
import { useHistory } from "react-router-dom";
import Literal from "../literals/Literal"

const Vote = () => {
  const [cookies, setCookie] = useCookies(['vote'])
  const { groupId, groupName, lang } = useParams()
  const [name, setName] = useState()
  const [option, setOption] = useState()
  const [teamName, setTeamName] = useState()
  const [error, setError] = useState(false)
  const [database, setDatabase] = useState()
  const history = useHistory();

  const errorLength = Literal('ERROR_MIN_LENGHT_1')
  const errorOption = Literal('ERROR_NO_OPTION')

  const getTeamName = async () => {
    const db = await new FirestoreService()
    setDatabase(db)
    db.getTeam(groupId).then(result => {
      if (result.name) {
        setTeamName(result.name)
      }
    }).catch((error) => console.log(error))
  }
  
  useEffect(() => {
    const vote = cookies[`ps-vote-${groupId}`]
    if (vote && vote.team && vote.team === groupId) {
      history.push(`/${lang || 'en'}/result/${groupId}/${groupName}`)
    }
    getTeamName()
  }, [])


  const submit = (event) => {
    event.preventDefault()
    if (!name || name.length <= 1) {
      setError(errorLength)
    } else if (!option) {
      setError(errorOption)
    } else {
      const addVote = async () => {
        database.addVote(groupId, teamName, name, parseInt(option)).then((result) => {
          if (result.resultUrl) {
            const cookieVote = {
              vote: parseInt(option),
              voterName: name,
              team: groupId,
            }
            setCookie(`ps-vote-${groupId}`, JSON.stringify(cookieVote), { path: '/' })
            history.push(`/${lang || 'en'}/result/${groupId}/${teamName}`)
          } else if (result.error) {
            setError(result.errorMessage)
          }
        }).catch((error) => console.log(error))
      }
      addVote()
    }
  }

  const handleOption = (event) => {
    setOption(event.target.value)
  }


  return (
    <>
      <Header showLogo={true} />
      <GridContainer>
        <Image option={option} />
        <div className={`flex flex-col items-center justify-center sm:col-start-2 sm:col-span-2 md:col-span-4 col-span-4 col-start-1 md:col-start-2 md:items-start ${(teamName) ? 'opacity-100' : 'opacity-0'} transition-opacity duration-500`}>
          <div className="self-center w-full max-w-md px-12 py-6 sm:px-4 md:hidden">
            <img src={logoVote} alt="VOTE YOUR WEEKEND" className="w-full"/>
          </div>
          <div className="flex items-center w-full mb-4">
            <div className="text-2xl text-center sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-secondary md:text-left">{teamName}</div>
            <div className="ml-4 underline text-purple font-secondary text-md sm:text-lg lg:text-xl">
              <Link to={`/result/${groupId}/${groupName}`} className="mb-4">{Literal('NAV_RESULT')}</Link>
            </div>
          </div>

          <form onSubmit={submit} className="flex flex-col items-center w-full text-md sm:text-lg lg:text-xl md:items-start">
            <label className="mb-2">{Literal('VOTE_YOUR_NAME')}</label>
            <input
              className="w-full h-12 p-2 mb-8 border border-button-red rounded-xl"
              type="text"
              onChange={event => setName(event.target.value)}
            />
            {error && <p className="w-full h-full mb-4 -mt-6 leading-none sm:-mt-6 sm:mb-8 text-red">{error}</p>}
            <label className="mb-4">{Literal('VOTE_CHOOSE_ONE')}</label>
            <div className="flex items-center w-full mb-4" onClick={() => setOption(1)}>
              <input
                name="option"
                id="option-1"
                value="1"
                type="radio"
                className="w-6 h-6 cursor-pointer"
                checked={parseInt(option) === 1}
                onChange={event => handleOption(event)}
              />
              <div className="w-full pl-4 ml-4 cursor-pointer bg-gradient-to-r from-options-orange">
                <label htmlFor="option-1" className="text-xl cursor-pointer lg:text-3xl sm:text-2xl font-secondary text-options-brown mix-blend-color-burn">
                  {Literal('OPTION_1')}
                </label>
              </div>
            </div>
            <div className="flex items-center w-full mb-4" onClick={() => setOption(2)}>
              <input
                name="option"
                id="option-2"
                value="2"
                type="radio"
                className="w-6 h-6 cursor-pointer"
                checked={parseInt(option) === 2}
                onChange={event => handleOption(event)}
              />
              <div className="w-full pl-4 ml-4 cursor-pointer bg-gradient-to-r from-options-green">
                <label htmlFor="option-2" className="text-xl cursor-pointer lg:text-3xl sm:text-2xl font-secondary text-options-blue mix-blend-color-burn">
                  {Literal('OPTION_2')}
                </label>
              </div>
            </div>
            <div className="flex items-center w-full mb-8 sm:mb-12" onClick={() => setOption(3)}>
              <input
                name="option"
                id="option-3"
                value="3"
                type="radio"
                className="w-6 h-6 cursor-pointer"
                checked={parseInt(option) === 3}
                onChange={event => handleOption(event)}
              />
              <div className="w-full pl-4 ml-4 cursor-pointer bg-gradient-to-r from-options-violet">
                <label htmlFor="option-3" className="text-xl cursor-pointer lg:text-3xl sm:text-2xl font-secondary text-options-purple mix-blend-color-burn">
                  {Literal('OPTION_3')}
                </label>
              </div>
            </div>
            <input type="submit" className="w-auto px-16 py-4 text-white rounded-full cursor-pointer font-secondary bg-button-red hover:opacity-80" value={Literal('VOTE_BUTTON_LABEL')}/>
          </form>
        </div>
      </GridContainer>
    </>
  )
}

export default Vote